import ContentHeader from '@/components/ContentHeader';
import { Collapse, Space } from 'antd';
import Head from 'next/head';
import React, { useState } from 'react';
import { GetServerSideProps } from 'next';
import { basicPageProps } from '@/utils/isServer';
import { CDN2 } from '@/helpers/api';

const { Panel } = Collapse;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { airports } = await basicPageProps(ctx);

  return {
    props: {
      airports,
    },
  };
};

export default function TermsOfService() {
  const [currentStep, setCurrentStep] = useState<number | null>(null);
  function handleTermsCollapseOnChange(current) {
    setCurrentStep(current);
  }
  return (
    <div>
      <Head>
        <title>Terms of Services | On Air Parking</title>
        <meta
          name="description"
          content="Hey there! By using the onairparking.com website (the 'Site'), you agree to be bound by the following terms and conditions (the 'Terms of Use' or 'Agreement'). As used in this Agreement, On Air Parking, Airport Valet Parking will be referred to as 'On Air Parking'."
          key="description"
        />
        <meta
          property="og:url"
          content="https://www.onairparking.com/termsofservice"
          key="og:url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta
          property="og:title"
          content="Terms of Services | On Air Parking"
          key="og:title"
        />
        <meta
          property="og:description"
          content="Hey there! By using the onairparking.com website (the 'Site'), you agree to be bound by the following terms and conditions (the 'Terms of Use' or 'Agreement'). As used in this Agreement, On Air Parking, Airport Valet Parking will be referred to as 'On Air Parking'."
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </Head>
      <ContentHeader btitle="Terms of Service" />
      <div className="container px-4 py-8 mx-auto w-full max-w-4xl bg-white flex flex-col justify-center items-center">
        <p className="text-lg text-center my-8">
          Hey there! By using the onairparking.com website (the "Site"), you
          agree to be bound by the following terms and conditions (the "Terms of
          Use" or "Agreement"). As used in this Agreement, On Air Parking,
          Airport Valet Parking will be referred to as "On Air Parking" or "we,"
          and you will be referenced as "you". This Agreement incorporates by
          reference the following policies and documents also found on this
          Site:{' '}
          <a
            className="text-primary"
            href="https://www.onairparking.com/privacypolicy"
          >
            Privacy Policy.
          </a>
        </p>
      </div>
      <div className="bg-gray-50">
        <div className="container max-w-4xl px-4 mx-auto pb-8">
          <h2 className="text-center text-2xl py-8 text-primary">Acceptance</h2>
          <p className="text-lg text-center mb-8">
            The following terms and conditions govern your use of the parking
            information, materials and documents being made available to you at
            this website, including, to the extent applicable, the Seller
            Console and other tools provided for users who sell parking
            ("Sellers") and the On Air Parking API and other tools provided for
            users who are developers ("Developers") (collectively, the
            "Materials").
          </p>
          <p className="text-lg text-center mb-8">
            By using the Materials, you signify your agreement to all terms,
            conditions, and notices contained or referenced herein. If you do
            not agree to these Terms of Use please do not use this Site or the
            Materials. We reserve the right, at our discretion, to update or
            revise these Terms of Use. Please check the Terms of Use
            periodically for changes. Your continued use of this Site or the
            Materials following the posting of any changes to the Terms of Use
            constitutes acceptance of those changes.
          </p>
        </div>
      </div>
      <div className="bg-white">
        <div className="container max-w-4xl px-4 mx-auto py-8">
          <Space direction="vertical" size="middle" className="w-full ">
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
              className="ant-collapse-terms"
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <div className="font-medium rounded-full h-6 w-6 p-2 bg-white flex flex-row justify-center items-center">
                      1
                    </div>
                    <span className="ml-2 items-start">
                      General Terms and ConditionsReservation of RightsThe On
                      Air Parking name and logo, and all related product and
                      service names, design marks and slogans are the trademarks
                      or registered trademarks of On Air Parking, Inc.
                    </span>
                  </div>
                }
                key="1"
                showArrow={true}
              >
                <p className="mb-4">
                  All other product and service marks contained herein are the
                  trademarks of their respective owners. You may not use any On
                  Air Parking or third party trademarks or logos without the
                  prior written consent of On Air Parking or the applicable
                  trademark owner. The service provided by On Air Parking is
                  limited to: (i) informing our customers of the location and
                  apparent availability of parking, and (ii) providing customers
                  the ability to book parking. Despite the convenience of our
                  service, the decision to utilize parking information remains
                  your responsibility and you assume that risk. The allocation
                  of parking spaces within a lot is solely in the control of the
                  lot attendant or uncontrolled if not attended. We therefore
                  cannot be responsible for any consequences arising from the
                  lack of suitable parking. In all cases the parking arrangement
                  will be governed by the agreement with the operator of the
                  parking facility as posted at their location or provided to
                  you by them.
                </p>
                <p className="mb-4">
                  For clarification, On Air Parking does not:
                </p>
                <p className="mb-4">
                  Provide a parking service, operate a parking lot or otherwise
                  accept custody of motor vehicles. That service is provided by
                  others and they are in no way our agents or acting in our
                  behalf;
                </p>
                <p className="mb-4">
                  Accept any responsibility whatsoever regarding the safety of
                  persons or property in the locations On Air Parkinged by our
                  customers;
                </p>
                <p className="mb-4">
                  Warrant that the Internet, our website or any email from us is
                  free of ‘viruses’ or other potentially harmful effects;
                </p>
                <p className="mb-4">
                  Endorse the use of cell-phones while driving;
                </p>
                <p className="mb-4">
                  Guarantee the availability of a specific parking spot in the
                  location you On Air Parkinged;
                </p>
                <p className="mb-4">
                  Assume any responsibility whatsoever for the consequences of
                  not being able to park or delays associated with parking.
                </p>
                <p className="mb-4">
                  This Site is intended for personal, noncommercial use (except
                  by Sellers and Developers in accordance with the applicable
                  terms and conditions set forth below). You may not use robots
                  or other automated means to access this Site, unless
                  specifically permitted by On Air Parking. You represent that
                  you are of sufficient legal age to create binding legal
                  obligations for any liability you may incur as a result of
                  your use of this Site. You agree to promptly update your
                  membership information (if applicable) in order to keep it
                  current, complete and accurate.
                </p>
                <p className="mb-4">
                  Please be aware that even if you do not give us your real
                  name, your Web browser transmits a unique Internet address to
                  us that can be used by law enforcement officials to identify
                  you. Fraudulent users will be prosecuted to the fullest extent
                  of the law.
                </p>
                <p className="mb-4">
                  Permission is granted to electronically copy and print in
                  hard-copy portions of this Site for the sole purpose of using
                  this Site as a shopping resource. Any other use of materials
                  or Content on this Site, including reproduction for a purpose
                  other than that noted above without On Air Parking’s prior
                  written consent is prohibited.
                </p>
                <p className="mb-4">
                  Privacy Policy; SecurityYou confirm that you have read and
                  accept our Privacy Policy, the terms of which are incorporated
                  herein, and agree that the terms of this policy are reasonable
                  and satisfactory to you. You consent to the use of your
                  personal information by On Air Parking, Inc. and/or its
                  third-party providers and distributors in accordance with the
                  terms of and for the purposes set forth in the Privacy Policy.
                </p>
                <p className="mb-4">
                  Privacy Policy; SecurityYou confirm that you have read and
                  accept our Privacy Policy, the terms of which are incorporated
                  herein, and agree that the terms of this policy are reasonable
                  and satisfactory to you. You consent to the use of your
                  personal information by On Air Parking, Inc. and/or its
                  third-party providers and distributors in accordance with the
                  terms of and for the purposes set forth in the Privacy Policy.
                </p>
                <p className="mb-4">
                  On Air Parking, Inc. makes no representation or warranty, and
                  hereby disclaims any and all liability, with regard to the
                  sufficiency of the security measures used for data handling
                  and storage. On Air Parking, Inc. will not be responsible for
                  any actual or consequential damages that result from a
                  security breach or technical malfunction.
                </p>
                <p className="mb-4">
                  User Comments, Feedback and Other SubmissionsAll comments,
                  feedback, suggestions and ideas disclosed, submitted or
                  offered to On Air Parking in connection with your use of this
                  Site (collectively, “Comments”), shall be and remain the
                  exclusive property of On Air Parking, Inc. and may be used by
                  On Air Parking in any medium and for any purpose worldwide
                  without obtaining your specific consent. For example, your
                  Comments could be used on this Site and in radio, television
                  and print advertisements. Your first name, first initial of
                  your last name, and town and state may be used with any
                  Comments you submit. On Air Parking is not under any
                  obligation to maintain your Comments (and the use of your
                  first name and first initial of your last name with any
                  comments) in confidence, to pay to you any compensation for
                  any Comments submitted, or to respond to any of your Comments.
                  You agree you will be solely responsible for the content of
                  any Comments you make.
                </p>
                <p className="mb-4">
                  Links to Other Web Sites and ServicesTo the extent this Site
                  contains links to outside services and resources, any such
                  links are provided for your convenience only. We do not
                  control those outside services or resource providers, and we
                  are not responsible for their contents or practices, including
                  their privacy practices. We do not endorse the operators of
                  those outside services or resource providers, nor do we
                  endorse or make any representations with respect to the
                  contents of their web sites or any products or services
                  offered on those web sites. Any concerns regarding such
                  services or resources should be directed to the particular
                  outside service or resource provider. On Air Parking does not
                  guarantee or warrant the accuracy or completeness of the
                  information or content included on the Web sites of these
                  outside services and resources.
                </p>
                <p className="mb-4">
                  User AccountsIn order to fully participate in all Site
                  activities, you must register for a personal account on the
                  Site (a “User Account”) by providing an email address and a
                  password for your User Account. You agree that you will never
                  divulge or share access or access information to your User
                  Account with any third party for any reason. You also agree to
                  that you will create, use, and access only one User Account,
                  and that you will not access the Site using multiple User
                  Accounts.
                </p>
                <p className="mb-4">
                  Ownership; SublicensingThe Site contains various information
                  in the form of data, text, graphics, and other materials from
                  On Air Parking and third parties (the “Site Content”). You
                  acknowledge that this Site and various elements contained
                  therein are protected by copyrights, trademarks, trade
                  secrets, patents, or other proprietary rights, and that these
                  worldwide rights are valid and protected in all forms, media,
                  and technologies existing now and hereinafter developed. You
                  also acknowledge that the Site Content is and shall remain the
                  property of On Air Parking or its licensors. You agree to
                  comply with all intellectual property laws and you shall not
                  encumber any interest in, or assert any rights to, the Site
                  Content. You may not modify, transmit, participate in the sale
                  or transfer of, or create derivative works based on any Site
                  Content, in whole or in part.
                </p>
                <p className="mb-4">
                  As between On Air Parking and you: (i) On Air Parking retains
                  all rights, title and interest in and to all intellectual
                  property rights embodied in or associated with the Site,
                  including, without limitation, the API, Database, On Air
                  Parking Content, trademarks, and any and all On Air Parking
                  services and any content created or derived therefrom
                  (collectively, the “On Air Parking IP”); and (ii) you and, to
                  the extent applicable, your suppliers retain all rights, title
                  and interest in and to all intellectual property rights
                  embodied in or associated with your site and your Application,
                  excluding (i) above and any other intellectual property rights
                  owned by On Air Parking. There are no implied licenses under
                  this Agreement, and any rights not expressly granted to you
                  hereunder are reserved by On Air Parking or its suppliers. You
                  shall not take any action inconsistent with On Air Parking’s
                  ownership of On Air Parking IP. Neither party shall exceed the
                  scope of the licenses granted hereunder. All license rights
                  (under any applicable intellectual property right) granted
                  herein are not sublicenseable, transferable or assignable.
                </p>
                <p className="mb-4">
                  UptimeOn Air Parking makes no guarantees with respect to the
                  availability or uptime of the On Air Parking Site, the API,
                  the On Air Parking Content or the Database. On Air Parking may
                  conduct maintenance on any of the foregoing at any time with
                  or without notice to you.
                </p>
                <p className="mb-4">
                  Termination of UsageUser access to all or part of this Site
                  may be terminated or suspended at any time, without notice and
                  for any reason.
                </p>
                <p className="mb-4">
                  Disclaimer and Liability LimitThe Site, the Site Content, the
                  API, the DataBase, and any other materials and products on
                  this Site are provided “as is” and without warranties of any
                  kind, whether express or implied. We assume no responsibility
                  for the accuracy of any information contained on our Site, for
                  any interruptions or errors in accessing our Site, or for any
                  viruses or other harmful components contained on our Site or
                  the server from which our Site is made available. We make no
                  warranties or representations regarding the use of the
                  materials in this Site in terms of their correctness,
                  accuracy, adequacy, usefulness, timeliness, reliability or
                  otherwise. WE DO NOT MAKE, AND HEREBY DISCLAIM, ANY AND ALL
                  WARRANTIES OF ANY KIND WITH RESPECT TO OUR SITE OR THE
                  PRODUCTS OR SERVICES OFFERED THROUGH OUR SITE, EITHER EXPRESS
                  OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                  WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                  PURPOSE, NON-INFRINGEMENT OR ANY WARRANTIES ARISING FROM A
                  COURSE OF PERFORMANCE, A COURSE OF DEALING OR TRADE USAGE.
                </p>
                <p className="mb-4">
                  UNDER NO CIRCUMSTANCES WILL WE OR OUR OFFICERS, DIRECTORS,
                  MEMBERS, MANAGERS, EMPLOYEES, AGENTS, SUPPLIERS OR SUCCESSORS
                  BE LIABLE TO ANY PERSON FOR ANY DIRECT, SPECIAL, INCIDENTAL,
                  PUNITIVE, INDIRECT OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
                  NOT LIMITED TO, LOSS OF PROFITS OR REVENUES, LOST DATA OR
                  INFORMATION, LOSS OF USE OF OUR SITE, BUSINESS INTERRUPTION,
                  LOSS OF BUSINESS REPUTATION OR GOODWILL, COSTS OF SUBSTITUTE
                  SERVICES, OR DOWNTIME COSTS) RELATING TO THE SITE OR THE
                  PRODUCTS OR SERVICES OFFERED ON OUR SITE OR RESULTING FROM
                  ACCESS TO OR OTHER USE OF OUR SITE OR RELIANCE ON ANY
                  INFORMATION PRESENTED ON OUR SITE, EVEN IF WE ARE INFORMED IN
                  ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES AND NOTWITHSTANDING
                  ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.
                </p>
                <p className="mb-4">
                  On Air Parking’s liability to you or anyone else in any
                  circumstance is limited to the lesser of (a) $100, and (b) the
                  total dollar amount of all parking booked via On Air Parking
                  in the 12 months prior to the action allegedly giving rise to
                  liability. Some jurisdictions do not allow the exclusion or
                  limitation of incidental or consequential damages, so the
                  above exclusions or limitations may not apply to you.
                </p>
                <p className="mb-4">
                  Some jurisdictions do not allow exclusion of certain
                  warranties or limitations of liability, so the above
                  limitations or exclusions may not apply to you. Our liability
                  in such case will be limited to the greatest extent permitted
                  by law.
                </p>
                <p className="mb-4">
                  Copyright ComplaintsIf you believe this Site contains any
                  content that infringes your copyright, please contact our
                  Copyright Agent, as detailed below, with the following
                  information:
                </p>
                <p className="mb-4">
                  An electronic or physical signature of the person authorized
                  to act on behalf of the owner of the copyright interest;
                </p>
                <p className="mb-4">
                  A description of the copyrighted work that you claim has been
                  infringed;
                </p>
                <p className="mb-4">
                  A description of where the material that you claim is
                  infringing is located on the Site;
                </p>
                <p className="mb-4">
                  Your address, telephone number and email address;
                </p>
                <p className="mb-4">
                  A statement by you that you have a good faith belief that the
                  disputed use is not authorized by the copyright owner, its
                  agent or the law; and
                </p>
                <p className="mb-4">
                  A statement by you, made under penalty of perjury, that the
                  above information in your notice is accurate and that you are
                  the copyright owner or duly authorized to act on the copyright
                  owner’s behalf.
                </p>
                <p className="mb-4">
                  To contact our Copyright Agent, please write, call or email
                  to:
                </p>
                <address className="mb-4">
                  Noson Inc.
                  <br />
                  Attn: Patrick Murray
                  <br />
                  21255 Burbank Blvd Ste 120
                  <br />
                  Woodland Hills, CA 91367
                  <br />
                  424-532-8940
                  <br />
                  <a
                    href="mailto:hello@noson.io"
                    className="text-primary underline mb-4"
                  >
                    hello@noson.io
                  </a>
                </address>
                <p className="mb-4">
                  Governing LawThis Agreement shall be governed by and
                  interpreted in accordance with the laws of the State of
                  Delaware, U.S.A., without regard to its provisions governing
                  conflicts of law. If we allege that you have infringed or
                  threatened to infringe our intellectual property rights, then,
                  in addition to any other rights and remedies we may have, we
                  may seek any preliminary or permanent injunctive relief from
                  any court of competent jurisdiction. You submit to the
                  exclusive jurisdiction of the state and federal courts located
                  in the State of Delaware and waive any jurisdictional, venue,
                  or inconvenient forum objections to such courts.
                </p>
                <p className="mb-4">
                  ModificationOn Air Parking, Inc. may at any time modify these
                  Terms of Use and your continued use of this Site will be
                  conditioned upon the terms and conditions in force at the time
                  of your use.
                </p>
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
              className="ant-collapse-terms"
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <div className="font-medium rounded-full h-6 w-6 p-2 bg-white flex flex-row justify-center items-center">
                      2
                    </div>
                    <span className="ml-2 items-start">
                      Additional Terms and Conditions Specific to BuyersBooked
                      Parking UsageUsers who book parking through the Site
                      ("Buyers") must present the On Air Parking parking pass in
                      accordance with the instructions included with the booking
                      to receive their guaranteed parking space on the day of
                      reservation. If the Buyer does not present the parking
                      pass to the Seller, the driver will not get credit for
                      their online payment and this online payment will not be
                      refunded at a later date.
                    </span>
                  </div>
                }
                key="2"
                showArrow={true}
              >
                <p className="mb-4">
                  Buyers are responsible for ensuring they arrive at their
                  booked parking location. On Air Parking is not liable for road
                  closures or changing traffic conditions.
                </p>
                <p className="mb-4">
                  The parking booked is valid only for the times listed on the
                  parking reservation or reciept.
                </p>
                <p className="mb-4">
                  If a parking facility allows tailgating on its premises, it is
                  the customer’s responsibility to comply and check any local
                  city ordinance codes on what is permissible (e.g., no open
                  flames, no cooking, etc.).
                </p>
                <p className="mb-4">
                  Resale of On Air Parking parking passes is not permitted.
                </p>
                <p className="mb-4">
                  Cancellations and Refunds. Parking booked through On Air
                  Parking is fully refundable up to the start of the reservation
                  unless noted otherwise. Parking customers can cancel their
                  booking for any reason before this time.
                </p>
                <p className="mb-4">
                  Users will not be charged any fees for reservations canceled
                  prior to the start of the reservation.
                </p>
                <p className="mb-4">
                  After the start of the parking reservation, all bookings are
                  non-refundable, even if the Buyer was unable to use the
                  parking.
                </p>
                <p className="mb-4">
                  Event Cancellations and Contingent Events. Unfortunately, the
                  circumstances surrounding postponed events are unpredictable.
                  Although we will try to help you resolve your parking
                  situation, we are not responsible for postponed events,
                  partial performances, or venue, date, or time changes. No
                  refunds will be issued.
                </p>
                <p className="mb-4">
                  Pricing. All parking prices published and displayed by On Air
                  Parking are set directly by the parking owner and operators,
                  not On Air Parking.
                </p>
                <p className="mb-4">
                  Lowest Price Guarantee. Parking advertised by On Air Parking
                  as “Lowest Price Guaranteed” is guaranteed to be the cheapest
                  parking rate available for that specific time and parking
                  location. Parking rates not advertised as “Lowest Price
                  Guaranteed” may differ from the drive-up rates, if available.
                </p>
                <p className="mb-4">
                  One day free promotion is subject to availability and company
                  discretion. Not valid with memberships or at facilities with a
                  daily price over $4.99.
                </p>
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
              className="ant-collapse-terms"
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <div className="font-medium rounded-full h-6 w-6 p-2 bg-white flex flex-row justify-center items-center">
                      3
                    </div>
                    <span className="ml-2 items-start">
                      Additional Terms and Conditions Specific to SellersOrder
                      of PrecedenceIn the event that a Seller has entered into a
                      separate written Seller Agreement with On Air Parking and
                      such Seller Agreement includes terms or conditions that
                      conflict with the terms and conditions in this Part III,
                      the terms and conditions of the Seller Agreement shall
                      govern.
                    </span>
                  </div>
                }
                key="3"
                showArrow={true}
              >
                <p className="mb-4">
                  Seller Console Subject to the terms and conditions of these
                  Terms of Use, On Air Parking hereby grants you a
                  non-exclusive, non-transferable, non-sublicensable, revocable
                  license to use the Seller Console and the information On Air
                  Parking provides or makes available to you in connection
                  therewith, solely for internal business purposes. You will not
                  (and will not permit any third party to) make any use or
                  disclosure of the Seller Console that is not expressly
                  permitted under this Agreement. Without limiting the
                  foregoing, you will not (and will not permit any third party
                  to): (i) reverse engineer, decompile, disassemble, or
                  otherwise attempt to discern the source code, algorithms, file
                  formats or interface protocols of the Seller Console or of any
                  files contained in or generated by the Seller Console; (ii)
                  copy, modify, adapt or translate the Seller Console, (iii)
                  resell, distribute or sublicense the Seller Console, make the
                  Seller Console available on a “service bureau” basis, or
                  otherwise allow any third party to use or access the Seller
                  Console, (iv) remove or modify any proprietary marking or
                  restrictive legends placed on the Seller Console; or (v) use
                  the Seller Console in violation of any applicable law or
                  regulation. As between On Air Parking and you, On Air Parking
                  retains title to and ownership of the Seller Console,
                  including all copyrights and other intellectual property
                  rights relating thereto. You will have no rights with respect
                  to the Seller Console other than those expressly granted under
                  this Agreement.
                </p>
                <p className="mb-4">
                  Fulfillment By listing parking for booking on On Air Parking,
                  the Seller agrees to honor any parking sold. All information
                  provided in the On Air Parking listing must be accurate. If
                  the Seller cannot fulfill the parking space or false
                  information about the parking is provided, On Air Parking will
                  hold the Seller liable to reimburse the Buyer for their
                  expense.
                </p>
                <p className="mb-4">
                  Note: It is illegal to sell parking that you do not own,
                  including street parking. Violation will result in immediate
                  termination of your On Air Parking account. On Air Parking
                  maintains the right to request proof of ownership to verify
                  your authority to sell parking at a particular location.
                </p>
                <p className="mb-4">
                  Payment On Air Parking guarantees payment to the Seller for
                  all bookings fulfilled by the Seller. Payment will be issued
                  in the form electronic bank transfer at the Seller’s request,
                  and will be processed in no more than 10 business days.
                </p>
                <p className="mb-4">
                  Taxes Seller assumes sole responsibility for filing and paying
                  all relevant state and local taxes, except income taxes, on
                  transactions originated by On Air Parking, and shall include
                  any applicable taxes in the Base Price set by Seller in the
                  Seller Console. On Air Parking shall have no obligation to
                  collect or remit any tax amounts. Seller shall indemnify On
                  Air Parking and hold On Air Parking harmless from and against
                  all state and local taxes, except income taxes, imposed on On
                  Air Parking that relate to transactions originated by On Air
                  Parking.
                </p>
                <p className="mb-4">
                  Contact Information The Buyer name and contact information is
                  provided to Sellers for the sole purpose of ensuring the
                  parking booking is fulfilled and may not be used by the Seller
                  for any other purpose.
                </p>
                <p className="mb-4">
                  Sellers must submit a phone number for each parking location
                  they list on On Air Parking. Buyers will be provided with this
                  number to call in the event of a problem with their parking.
                  Buyers will be eligible for a refund at the Seller’s expense
                  if this number is not answered during the parking reservation
                  period.
                </p>
                <p className="mb-4">
                  Making Adjustments Sellers authorize us to with hold payment
                  or charge their credit card account any amount owed to On Air
                  Parking if (a) a sale is cancelled for any reason; (b) an
                  adjustment is made under our On Air Parking Guarantee; © we
                  reasonably believe that a Seller has committed fraud or other
                  illegal act or omission during any buying or selling activity;
                  (d) Seller provides incorrect or misrepresented parking and/or
                  parking related services for any booking or portion thereof.
                </p>
                <p className="mb-4">
                  Dispute Resolution The On Air Parking Guarantee provides
                  Buyers the protection and motivation to book their parking at
                  <a href="https://onairparking.com">onairparking.com</a>. Thus,
                  we require On Air Parking sellers to comply with our
                  resolution process in case a Buyer files a claim that they did
                  not receive parking as per the terms of the On Air Parking
                  Guarantee. Sellers permit us to make a final decision, in our
                  sole discretion, on any claim that a Buyer files with On Air
                  Parking under the On Air Parking Guarantee. If we resolve a
                  dispute in the Buyer’s favor, we will refund the Buyer for the
                  cost of the parking, and we will require the Seller to
                  reimburse us for the refund. Any On Air Parking fees for the
                  booking will be refunded to the Seller. A warning notice will
                  also be sent to the Seller.
                </p>
                <p className="mb-4">
                  For future claims where the Seller is found at fault after a
                  warning has been issued, we will notify the Seller and
                  continue to charge the sellers for any reimbursements made
                  under the On Air Parking Guarantee, plus a $15 fee will be
                  assessed to cover chargebacks and other associated bank
                  charges. On Air Parking maintains the right to suspend or
                  terminate a Seller’s account if we suspect abuse or continuous
                  account violations.
                </p>
                <p className="mb-4">
                  Grant of LicenseYou grant On Air Parking a perpetual,
                  non-exclusive, transferable, worldwide, irrevocable,
                  royalty-free right to exercise publicity, database, trademark
                  and copyright rights, including the right to reproduce,
                  modify, adapt, publish and display on the Site and on the
                  sites of our partners and affiliated companies, any content
                  you may provide to On Air Parking in connection with your use
                  of On Air Parking and its Services. You agree that On Air
                  Parking shall be permitted to use your name or user ID, home
                  city and other ancillary information (for example, the number
                  of years you have been a On Air Parking user) in connection
                  with the content in conjunction with On Air Parking’s
                  marketing, promotion and publicity efforts in any media known
                  now or in the future.
                </p>
                <p className="mb-4">
                  Indemnity You agree to indemnify and hold On Air Parking and
                  (if applicable) any parent, subsidiaries, selling partners,
                  affiliates, officers, directors, attorneys, agents and
                  employees, harmless against any claim or demand and all
                  liabilities, costs and expenses (including reasonable
                  attorneys’ fees) incurred by On Air Parking and (if
                  applicable) any parents, subsidiaries, affiliates, selling
                  partners, officers, directors, agents, attorneys and employees
                  that arise out of any claim asserted by a third party that
                  involves, relates to or concerns any of your actions or
                  omissions on this Site, including but not limited to your
                  breach of this Agreement, or your violation of any law or the
                  rights of a third party.
                </p>
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
              className="ant-collapse-terms"
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <div className="font-medium rounded-full h-6 w-6 p-2 bg-white flex flex-row justify-center items-center">
                      4
                    </div>
                    <span className="ml-2 items-start">
                      Additional Terms and Conditions Specific to DevelopersAPI
                      LicenseSubject to the terms and conditions of these Terms
                      of Use, On Air Parking hereby grants you a non-exclusive,
                      non-transferable, non-sublicenseable, revocable license to
                      use the API and the information On Air Parking provides or
                      makes available to you (the "On Air Parking Content")
                      solely in accordance with this Agreement. You may do the
                      following under this Agreement:
                    </span>
                  </div>
                }
                key="4"
                showArrow={true}
              >
                <p className="mb-4">
                  Enable the software application that you develop, own and
                  operate (your “Application”) to interact with the On Air
                  Parking public database (the “Database”) and retrieve
                  therefrom information necessary to facilitate the use of{' '}
                  <a href="https://www.onairparking.com">
                    www.onairparking.com
                  </a>{' '}
                  and all other web sites that are owned or operated by On Air
                  Parking (collectively, the “On Air Parking Site”) by third
                  parties through your Application in accordance with this
                  Agreement (the “Permitted Use”);
                </p>
                <p className="mb-4">
                  Make limited intermediate copies of the On Air Parking Content
                  only as necessary to perform an activity permitted under this
                  Agreement; and
                </p>
                <p className="mb-4">
                  Display On Air Parking Content in accordance with these Terms
                  of Use (including all materials provided to you by On Air
                  Parking or contained on the Developer Site).
                </p>
                <p className="mb-4">
                  You may engage in the activities permitted above solely for
                  the Permitted Use.
                </p>
                <p className="mb-4">
                  On Air Parking shall provide you with confidential security
                  keys and related passwords, if necessary (collectively, the
                  “Client ID”) that will permit you to access the Database. The
                  Client ID is the property of On Air Parking and may be
                  immediately revoked or terminated by On Air Parking if you
                  share the same with any third party, if compromised by a third
                  party or if you use or access the API, On Air Parking Content
                  or the Database in any way not expressly permitted under this
                  Agreement. On Air Parking reserves the right to modify,
                  change, update and/or enhance the API, permitted API calls,
                  the Database, the Permitted Use and/or the On Air Parking Site
                  (each a “Modification”) at any time with or without notice to
                  you in On Air Parking’s sole and exclusive discretion. You
                  acknowledge and agree that such Modifications may affect your
                  Application and/or your site and may require you to make
                  changes to your Application and/or your site at your cost to
                  enable your Application and/or your site to continue to be
                  compatible with, and/or interface with, the API, Database or
                  the On Air Parking Site. Without limiting the “Disclaimer of
                  Other Warranties and Limitation of Liability” section below,
                  On Air Parking shall not be liable for any costs incurred by
                  you, lost profits or damages of any kind arising out of or in
                  connection with any Modification.
                </p>
                <p className="mb-4">
                  On Air Parking reserves the right to terminate this license at
                  any time for any reason upon written notice to you. Upon such
                  termination, you shall immediately cease any and all use of
                  the On Air Parking Content.
                </p>
                <p className="mb-4">
                  General License Conditions and RestrictionsYour use of the On
                  Air Parking API is subject to the following conditions:
                </p>
                <p className="mb-4">
                  You shall not use the API, the Database or the On Air Parking
                  Content in any way not expressly permitted or granted under
                  this Agreement;
                </p>
                <p className="mb-4">
                  During the term of this Agreement and following its expiration
                  or early termination, you shall not use (or facilitate use of)
                  any alternative means such as robots, spyders, scraping or
                  other technology to access, query or use the On Air Parking
                  Site, the Database or On Air Parking Content to obtain any
                  information, other than as provided by On Air Parking to you
                  pursuant to this Agreement;
                </p>
                <p className="mb-4">
                  You shall not distribute, publish, facilitate, enable or allow
                  access or linking to the On Air Parking Content or Database
                  from any location or source other than through your
                  Application;
                </p>
                <p className="mb-4">
                  You shall not provide On Air Parking Content to any third
                  parties not expressly authorized by this Agreement and you
                  shall not permit or enable third parties to copy or obtain On
                  Air Parking Content from your Application or your site in any
                  unauthorized manner including, but not limited to, the use of
                  using robots, spyders, scraping or any other technology;
                </p>
                <p className="mb-4">
                  You shall not collect personally identifiable information of
                  any user of the On Air Parking Site through your Application;
                </p>
                <p className="mb-4">
                  You shall not modify, decompile, attempt to reverse engineer,
                  or otherwise alter the API or the Database;
                </p>
                <p className="mb-4">
                  You shall not commercialize (i.e., sell, rent or lease), copy,
                  store or cache the On Air Parking Content, other than for the
                  intermediate purposes allowed by this Agreement;
                </p>
                <p className="mb-4">
                  Your Application and your use of the API, On Air Parking
                  Content and Database shall not: (i) be false, inaccurate or
                  misleading; (ii) infringe on any third party’s copyright,
                  patent, trademark, trade secret or other property rights or
                  rights of publicity or privacy; (iii) violate any law,
                  statute, ordinance, contract or regulation (including, but not
                  limited to, those governing financial services, consumer
                  protection, unfair competition, antidiscrimination or false
                  advertising); (iv) be defamatory, trade libelous, unlawfully
                  threatening or unlawfully harassing; (v) contain any viruses,
                  Trojan horses, worms, time bombs, cancelbots, easter eggs or
                  other computer programming routines that may damage,
                  detrimentally interfere with, surreptitiously intercept or
                  expropriate any system, data or other personal information; or
                  (vi) create liability for us or cause us to lose (in whole or
                  in part) the services of any internet service provider or
                  other suppliers; and
                </p>
                <p className="mb-4">
                  You shall not knowingly create a software application that may
                  be used to violate the On Air Parking Terms of Use set forth
                  in this document or any other On Air Parking policy.
                </p>
                <p className="mb-4">
                  You shall not use the On Air Parking Content in any manner
                  that competes directly or indirectly with On Air Parking.
                </p>
                <p className="mb-4">
                  Approval You shall be responsible for all costs you incur in
                  association with any required approval of your Application and
                  any modifications necessary to meet the approval criteria and
                  you will not be permitted to publicly display your Application
                  until approval is complete.
                </p>
                <p className="mb-4">
                  Display of On Air Parking ContentYou may only display the On
                  Air Parking Content in accordance with the guidelines set
                  forth herein (including those provided to you by On Air
                  Parking or contained in the Developer Site).
                </p>
                <p className="mb-4">
                  Display of LogoOn Air Parking hereby grants you a
                  non-exclusive license to display the On Air Parking Logo as
                  described herein (including those provided to you by On Air
                  Parking or contained in the Developer Site). Notwithstanding
                  anything to the contrary herein, On Air Parking shall retain
                  final approval over the placement of each such On Air Parking
                  Logo on your Application and your site, which such approval
                  may be withdrawn or withheld in On Air Parking’s sole
                  discretion.
                </p>
                <p className="mb-4">
                  Competitive or Similar Materials In no event shall On Air
                  Parking be precluded from discussing, reviewing, developing
                  for itself, having developed, acquiring, licensing or
                  developing for third parties, as well as marketing and/or
                  distributing, materials which are competitive with your
                  Application and/or other products or services provided by you
                  (collectively, “Products”), irrespective of their similarity
                  to current Products or Products that you may develop
                  hereafter.
                </p>
                <p className="mb-4">
                  API Call Limitations The number of API calls you will be
                  permitted to make during any given time period will be limited
                  as described in the materials provided to you by On Air
                  Parking or on the Developer Site. On Air Parking will
                  determine, in its sole and exclusive discretion, such API call
                  limit (the “Call Limitation”) based on various factors On Air
                  Parkinged by On Air Parking. Such factors may include, without
                  limitation, the ways in which your Application may be used
                  and/or the anticipated volume of usage associated with your
                  Application. On Air Parking may, in its sole and exclusive
                  discretion, suspend your access to the API with or without
                  notice to you in the event you exceed the Call Limitation.
                </p>
                <p className="mb-4">
                  Security and Stability You acknowledge that it is in the best
                  interests of both parties that On Air Parking maintain a
                  secure and stable environment, to that end, On Air Parking
                  reserves the right to change the method of access to the API,
                  the Database and/or On Air Parking Content at any time. You
                  also agree that, in the event of degradation or instability of
                  On Air Parking’s system or an emergency, On Air Parking may,
                  in its sole discretion, temporarily suspend your access to the
                  API, Database and/or On Air Parking Content under this
                  Agreement. Your continued access to the API, Database and On
                  Air Parking Content is subject to your compliance with the
                  following security standards:
                </p>
                <p className="mb-4">
                  You agree to maintain reasonable safeguards to protect the
                  security of all information provided to you by On Air Parking
                  and to use such information only as intended under this
                  Agreement.
                </p>
                <p className="mb-4">
                  You agree to adhere at all times to reasonable security
                  practices, as specified in current industry literature on
                  topics relevant to your interaction with On Air Parking.
                </p>
                <p className="mb-4">
                  You agree to immediately notify On Air Parking in writing upon
                  your discovery a breach of security of your facility, systems
                  or site where On Air Parking Content or data relating to any
                  use of the On Air Parking Site has been acquired by an
                  unauthorized person.
                </p>
                <p className="mb-4">
                  In addition to the foregoing, you agree that On Air Parking
                  may monitor your use of the API, your Application and the On
                  Air Parking content in order to ensure that all such use is
                  proper and intended primarily to direct customers to the On
                  Air Parking site for legitimate purposes.
                </p>
                <p className="mb-4">Membership</p>
                <p className="mb-4">
                  Purchasing an annual membership from our website allots you as
                  a user no “NOSON fee” charge for 12 months from your purchase
                  date. After this date your membership will no longer be valid
                  and will need to be renewed.
                </p>
                <p className="mb-4">
                  Memberships may not be transferred, cancelled or refunded for
                  any reason.
                </p>
                <p className="mb-4">
                  All users of this website agree to indemnify and save harmless
                  NOSON Inc. and our employees, agents, and shareholders from
                  any and all costs, claims, and damages… In addition you agree
                  to indemnify and save harmless our partners and their
                  employees, agents, and shareholders from any and all costs,
                  claims, and damages.
                </p>
              </Panel>
            </Collapse>
          </Space>
        </div>
      </div>
    </div>
  );
}
